import styled from '@emotion/styled';
import { boxShadow, color, transition } from '@shared/constants/Styles';

// TODO DEPRECATE we now use Card from cards/Card.tsx

const LegacyCard = styled.div`
    transition: ${transition.default};
    overflow: hidden;
    border-radius: 10px;
`;

export const CardStyle = styled.div`
    transition: ${transition.default};
    background-color: ${(props) => props.theme.color.background};
    border-radius: 10px;
`;

export const ClickableCard = styled(LegacyCard)`
    cursor: pointer;
    &:hover {
        box-shadow: ${boxShadow.hover};
    }
    &:focus-within {
        outline: ${color.accent} auto 2px;
    }
`;

export default LegacyCard;
